// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qX5_","content":"styles_content__1XGtM"};